import { Card, IconButton } from "@mui/material";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
// import VisibilityIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import Date from "../../../../../utils/date";
import { CertificadoPdf } from "./certificado/certificadopdf";
import { DesalfandegamentoPDF } from "./desalfandegamento/desalfandegamentoPDF";
import { CertificadoNCotroladoPdf } from "./certificado/certificadoNCotroladoPdf";


export default function DocumentosEmitidos({ solicitacaoImportacao }) {
    // console.log(solicitacaoImportacao)

    return (
        solicitacaoImportacao?.certificado &&
        <Card style={{ padding: 15, borderRadius: 5 }}>

            <HeaderGestorConfigs title={'CERTIFICADOS EMITIDOS'} />

            {solicitacaoImportacao?.solicitacaoArea === 'Não Controlados' ?
            // {solicitacaoImportacao?.certificado[0]?.productoRefente?.tipo === 'Não Controlados' ?
                <p>
                    <IconButton color="secondary"
                        onClick={() => { CertificadoNCotroladoPdf(solicitacaoImportacao, solicitacaoImportacao?.certificado) }}
                    >
                        <DownloadOutlinedIcon />
                    </IconButton>

                    CERTIFICADO DE IMPORTAÇÃO_NÃO CONTROLADOS_ <Date date={solicitacaoImportacao?.certificado[0]?.dataEmissao} />
                </p>
                : solicitacaoImportacao?.certificado.map((certificado) =>
                    <p>
                        <IconButton color="secondary"
                            onClick={() => { CertificadoPdf(solicitacaoImportacao, certificado) }}
                        >
                            <DownloadOutlinedIcon />
                        </IconButton>

                        CERTIFICADO DE IMPORTAÇÃO_{certificado?.productoRefente?.nome}_{certificado?.numeroCertificado} _ <Date date={certificado.dataEmissao} />
                    </p>)
            }

            {solicitacaoImportacao?.declaracao?.dataAprovacao &&
                <>
                    <HeaderGestorConfigs title={'DECLARAÇÃO EMITIDA PARA DESALFANDEGAMENTO'} />
                    <p>
                        <IconButton color="secondary"
                            onClick={() => { DesalfandegamentoPDF(solicitacaoImportacao) }}
                        >
                            <DownloadOutlinedIcon />
                        </IconButton>

                        DECLARAÇÃO DE DESALFANDEGAMENTO_{solicitacaoImportacao?.declaracao?.numeroDeclaracao} _ <Date date={solicitacaoImportacao?.declaracao.dataEmissao} />
                    </p>
                </>
            }
            {/* <Date date={solicitacaoImportacao?.declaracao.dataDespacho} */}

        </Card>
    )
}
